import React, { useEffect, useRef, useState } from 'react'
import axios from '../../API/axios';
import { recordSearch } from '../../API/searchHistory';
import JobList from './JobList';
import SearchHeader from './SearchHeader';
import JobFilter from './JobFilter';
import { header } from "../../config/imagesLink";
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GoogleAdUnit from '../../components/GoogleAdUnit';
import AutoAwesomeSharpIcon from '@mui/icons-material/AutoAwesomeSharp';
import WorkOutlineSharpIcon from '@mui/icons-material/WorkOutlineSharp';
import "./JobSearchRedesign.css";

const JobSearch = () => {

    const scrollContainerRef = useRef();
    const listGenerationRef = useRef(0);
    const isFetchingMoreRef = useRef(false);
    const pageRef = useRef(1);
    const totalPagesRef = useRef(1);
    const skipNextFilterEffectRef = useRef(false);
    const filtersSnapshotRef = useRef(null);

    const getFiltersSnapshot = () =>
        JSON.stringify({
            debouncedSearch,
            selectedCountryData,
            selectedCity,
            selectedCompanyData,
            selectedDesignationData,
            selectedJobTypeData,
            selectedSalaryType,
            selectedWorkLocation,
            selectedWorkLevel,
            completenessFilter,
        });
    const { t } = useTranslation();
    const sessionId = localStorage.getItem("sessionId");
    const guestModeData = localStorage.getItem("guestMode");
    const userUid = localStorage.getItem("userUid");
    const [filterJobList, setFilterJobList] = useState([]);
    const [country, setCountry] = useState([]);
    const [selectedCountryData, setSelectedCountryData] = useState([]);
    const [city, setCity] = useState([]);
    const [selectedCity, setSelectedCity] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompanyData, setSelectedCompanyData] = useState([]);
    const [designationList, setDesignationList] = useState([]);
    const [selectedDesignationData, setSelectedDesignationData] = useState([]);
    const [selectedJobTypeData, setSelectedJobTypeData] = useState([]);
    const [jobTypeList, setJobTypeList] = useState([]);
    const [salaryTypeList, setSalaryTypeList] = useState([]);
    const [selectedSalaryType, setSelectedSalaryType] = useState([]);
    const [selectedWorkLevel, setSelectedWorkLevel] = useState([]);
    const [workLevelTypeList, setWorkLevelTypeList] = useState([]);
    const [workLocationType, setWorkLocationTypeList] = useState([]);
    const [selectedWorkLocation, setSelectedWorkLocationList] = useState([]);
    const ProfilePercent = localStorage.getItem("ProfilePercentage"); 

    //************************ jobs list Start  ************************//
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [jobsList, setJobsList] = useState([]);
    const [searchjobsList, setSearchJobsList] = useState([]);
    const [isError, setIsError] = useState(false);
    const [reset, setReset] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [hasMoreData, setHasMoreData] = useState(true);
    const [nextBatchLoading, setNextBatchLoading] = useState(false);
    const [debouncedSearch, setDebouncedSearch] = useState(searchValue);
    const [completenessFilter, setCompletenessFilter] = useState("all");

    useEffect(() => {
        pageRef.current = page;
    }, [page]);

    useEffect(() => {
        totalPagesRef.current = totalPages;
    }, [totalPages]);

    useEffect(() => {
        if (!nextBatchLoading && !isLoading) {
            isFetchingMoreRef.current = false;
        }
    }, [nextBatchLoading, isLoading]);

    const getAllJobList = (page, options = {}) => {
        const { replaceList = false } = options;
        const isFirstPage = page === 1;
        const requestGeneration = listGenerationRef.current;

        if (isFirstPage) {
            setIsLoading(true);
            setNextBatchLoading(false);
            if (replaceList) {
                setJobsList([]);
                setIsError(false);
            }
        } else {
            setNextBatchLoading(true);
        }

        const data = {
            search: debouncedSearch,
            countryIDs: selectedCountryData,
            cityIDs: selectedCity,
            companyIDs: selectedCompanyData,
            jobtypeIDs: selectedJobTypeData,
            workLevelTypeIDs: selectedWorkLevel,
            workLocationTypeIDs: selectedWorkLocation,
            salaryTypeIDs: selectedSalaryType,
            designationIDs: selectedDesignationData,
            skillIDs: [],
            deviceType: "Web",
            pageNumber: page,
            pageSize: 12,
            completenessFilter: completenessFilter === "all" ? null : completenessFilter,
        };

        if (isFirstPage && debouncedSearch?.trim()) {
            recordSearch({ searchKey: debouncedSearch, typeId: 2 });
        }

        axios
            .post(`Job/GetJobsWithFilters`, data)
            .then((response) => {
                if (requestGeneration !== listGenerationRef.current) {
                    return;
                }

                if (response.status === 204) {
                    setIsError(true);
                    if (isFirstPage) {
                        setJobsList([]);
                    }
                } else {
                    setIsError(false);
                    const responseTotalPages = response.data.responseData.paging.totalPages;
                    setTotalPages(responseTotalPages);
                    setCountry(response.data.responseData.filters.countryList || []);
                    setCity(response.data.responseData.filters.cityList || []);
                    setCompanyList(response.data.responseData.filters.companyList || []);
                    setDesignationList(response.data.responseData.filters.designationList || []);
                    setJobTypeList(response.data.responseData.filters.jobTypeList || []);
                    setSalaryTypeList(response.data.responseData.filters.salaryTypeList || []);
                    setWorkLevelTypeList(response.data.responseData.filters.workLevelTypeList || []);
                    setWorkLocationTypeList(response.data.responseData.filters.workLocationTypeList || []);
                    const newPosts = response.data.responseData.jobs || [];

                    setJobsList((prev) => {
                        if (isFirstPage || replaceList || reset) {
                            if (reset) {
                                setReset(false);
                            }
                            return newPosts;
                        }

                        const postSet = new Set(prev.map((p) => p.jobId));
                        const uniqueNewPosts = newPosts.filter((p) => !postSet.has(p.jobId));
                        return [...prev, ...uniqueNewPosts];
                    });

                    setHasMoreData(page < responseTotalPages);
                }

                if (isFirstPage) {
                    setIsLoading(false);
                } else {
                    setNextBatchLoading(false);
                }
            })
            .catch((error) => {
                if (requestGeneration !== listGenerationRef.current) {
                    return;
                }

                if (error.response && error.response.status === 404) {
                    setIsError(true);
                    if (isFirstPage) {
                        setJobsList([]);
                    }
                } else {
                    console.log(error);
                }

                setReset(false);

                if (isFirstPage) {
                    setIsLoading(false);
                } else {
                    setNextBatchLoading(false);
                }
            });
    };
   

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchValue);
        }, 1000); // 500ms pause ke baad update hoga

        return () => clearTimeout(timer);
    }, [searchValue]);
    useEffect(() => {
        if (page > 1 && !reset && hasMoreData && page <= totalPages) {
            getAllJobList(page);
        }
    }, [page]);

    useEffect(() => {
        const currentSnapshot = getFiltersSnapshot();

        if (skipNextFilterEffectRef.current) {
            skipNextFilterEffectRef.current = false;
            filtersSnapshotRef.current = currentSnapshot;
            return;
        }

        if (filtersSnapshotRef.current === currentSnapshot) {
            return;
        }

        filtersSnapshotRef.current = currentSnapshot;
        listGenerationRef.current += 1;
        isFetchingMoreRef.current = false;
        setPage(1);
        setHasMoreData(true);
        getAllJobList(1, { replaceList: true });
    }, [
        debouncedSearch,
        selectedCountryData,
        selectedCity,
        selectedCompanyData,
        selectedDesignationData,
        selectedJobTypeData,
        selectedSalaryType,
        selectedWorkLocation,
        selectedWorkLevel,
        completenessFilter
    ]);

    const handleInfiniteScroll = () => {
        if (
            window.innerHeight + window.scrollY >= document.body.scrollHeight - 100 &&
            !nextBatchLoading &&
            !isFetchingMoreRef.current &&
            hasMoreData &&
            !isLoading &&
            !reset &&
            pageRef.current < totalPagesRef.current
        ) {
            isFetchingMoreRef.current = true;
            setPage((prev) => {
                if (prev >= totalPagesRef.current) {
                    isFetchingMoreRef.current = false;
                    return prev;
                }
                return prev + 1;
            });
        }
    };

    //************************ jobs list End  ************************//

    const [alert, setAlert] = useState(false);
    const [isLoadingalert, setIsLoadingalert] = useState(true); // Add loading state

    const normalizedUserPer = Array.isArray(ProfilePercent) ? (ProfilePercent.length === 0 ? 0 : Number(ProfilePercent[0])) : Number(ProfilePercent);

    const shouldShowAlert = !isLoadingalert || normalizedUserPer <= 59 && alert === false && guestModeData === null;

    useEffect(() => {
        window.addEventListener("scroll", handleInfiniteScroll);
        return () => window.removeEventListener("scroll", handleInfiniteScroll);
    }, [nextBatchLoading, hasMoreData, isLoading, reset]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <>
            <Helmet>
                <title>Search Job | Welinkjobs </title>
                <meta name="description" content="Unleash your job search potential with Welinkjobs. Explore opportunities on the most trusted job search sites and find your dream job." />
                {/* <meta name="keywords" content="react, meta tags, seo" /> */}
                {/* <meta name="author" content="Your Name" /> */}
                <meta property="og:title" content="Find Your Next Opportunity: Welinkjobs Jobs Search" />
                <meta property="og:description" content="Unleash your job search potential with Welinkjobs. Explore opportunities on the most trusted job search sites and find your dream job." />
                {/* <meta property="og:image" content="https://example.com/image.jpg" /> */}
                <meta property="og:url" content="https://welinkjobs.com/SearchJob" />
            </Helmet>
            <div className="p-lg-5 p-md-2 p-2 mt-5 PaddingTop padding-bottom">
                <div className="job-search-hero">
                    <div className="js-hero-content">
                        <span className="js-hero-kicker">
                            <AutoAwesomeSharpIcon />
                            {t("SearchJob.Search")}
                        </span>
                                                <h1>{t("SearchJob.Find Your Next Job")}</h1>
                        <p>{t("SearchJob.Search hundreds of opportunities from top companies and find the role that fits you.")}</p>
                        <div className="js-hero-count">
                            <span className="js-count-pill">{jobsList.length} {t("SearchJob.jobs")}</span>
                            <span><WorkOutlineSharpIcon style={{ fontSize: "16px", verticalAlign: "middle" }} /> {t("SearchJob.See all results")}</span>
                        </div>
                    </div>
                </div>
                {shouldShowAlert && (
                    <div className='p-3 closeAccount m-0 mb-3 mt-1'>
                        <div className='d-flex mb-3 align-items-center'>
                            <InfoSharpIcon />
                            <span className='cardHeader ms-1'>{t("Newsfeed.Announcement")} </span>
                            <span className="ms-auto">
                                <CloseSharpIcon
                                    style={{ width: '20px' }}
                                    className="pointer"
                                    onClick={() => setAlert(true)} // Dismiss the alert
                                />
                            </span>
                        </div>
                        <div>
                            <span>{t("Newsfeed.Accounce")} </span>


                            <Link to={`/User/${userUid}`} className="border-bottom f-600 warn-resume">
                                {t("Newsfeed.Manage Profile")}
                                {/* Manage Profile */}
                            </Link>
                        </div>
                    </div>
                )}
                {/* {(guestModeData === 'false'|| guestModeData===null) && userPer <= 60 && alert === false && (
                    <div className='p-3 closeAccount m-0 mb-3'>
                        <div className='d-flex mb-3 align-items-center'>
                            <InfoSharpIcon />
                            <span className='cardHeader ms-1'>Announcement!</span>
                            <span className="ms-auto">
                                <CloseSharpIcon style={{ width: '20px' }} className="pointer" onClick={() => {
                                    setAlert(true);
                                }} />
                            </span>
                        </div>
                        <div>
                            <span>Applying for a new job ! Update your profile and resume Now.</span>

                        </div>
                        <div className=" mt-2">
                    <Link to={`/User/${userUid}`}>
                       <button
                          color=""
                           className="closebtn"
                             style={{ width: "150px" }}  >
                        Manage Profile
                      </button>
                    </Link>
                </div>
                    </div>)} */}
                <div className="advertiseImage">
                    {/* <img src={NewsFeed.Advertise} alt="" /> */}
                    <div className="advertisementview mb-2">
                        <div className="advertisementContainer" style={{
                            width: "100%",
                            height: "180px", // Set a fixed height
                            overflow: "hidden", // Prevent overflow issues
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',

                        }}>
                            <GoogleAdUnit
                                adSlot="9135916775"
                                style={{
                                    display: "block",
                                    width: "100%",
                                    height: "100%",
                                    margin: "0 auto",
                                }}
                            />
                        </div>
                        {/* <h1 className="adText">Advertisement</h1> */}
                    </div>

                </div>
                <div className="job-search-workspace">
                <SearchHeader
                    country={country || []}
                    city={city || []}
                    companyList={companyList || []}
                    designationList={designationList || []}
                    selectedCountryData={selectedCountryData || []}
                    setSelectedCountryData={setSelectedCountryData || []}
                    selectedCity={selectedCity || []}
                    setSelectedCity={setSelectedCity || []}
                    selectedCompanyData={selectedCompanyData || []}
                    setSelectedCompanyData={setSelectedCompanyData || []}
                    selectedDesignationData={selectedDesignationData || []}
                    setSelectedDesignationData={setSelectedDesignationData || []}
                    setReset={setReset}
                />
                <div className="row jobMainContainer job-search-main-row">
                    <div className="col-lg-3 col-md-4 job-search-sidebar">
                        <div className="job-search-sidebar-inner">
                        <JobFilter
                            setJobsList={setJobsList}
                            jobsList={jobsList}
                            setSelectedJobTypeData={setSelectedJobTypeData || []}
                            jobTypeList={jobTypeList || []}
                            salaryTypeList={salaryTypeList || []}
                            setSelectedSalaryType={setSelectedSalaryType || []}
                            workLevelTypeList={workLevelTypeList || []}
                            setSelectedWorkLevel={setSelectedWorkLevel || []}
                            workLocationType={workLocationType || []}
                            setSelectedWorkLocationList={setSelectedWorkLocationList || []}
                            setReset={setReset}
                        />
                        <div className="advertiseImage job-search-sidebar-ad">
                            <div className="advertisementview">
                                <div className="advertisementContainer" style={{
                                    width: "100%",
                                    height: "200px",
                                    overflow: "hidden",
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <GoogleAdUnit
                                        adSlot="9135916775"
                                        style={{
                                            display: "block",
                                            width: "100%",
                                            height: "100%",
                                            margin: "0 auto",
                                        }}
                                    />
                                </div>
                                <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-9 col-md-8 job-search-list-column">
                        <div className="d-flex flex-wrap gap-2 mb-3">
                            {[
                                { id: "all", label: "All jobs" },
                                { id: "complete", label: "Complete" },
                                { id: "incomplete", label: "Incomplete" },
                                { id: "missingWeights", label: "No weights" },
                                { id: "weightageGap", label: "Weightage gap" },
                                { id: "stale", label: "Stale" },
                            ].map((chip) => (
                                <button
                                    key={chip.id}
                                    type="button"
                                    className={`btn btn-sm ${completenessFilter === chip.id ? "btn-primary" : "btn-outline-secondary"}`}
                                    onClick={() => setCompletenessFilter(chip.id)}
                                >
                                    {chip.label}
                                </button>
                            ))}
                        </div>
                        <JobList
                            refContainer={scrollContainerRef}
                            jobsList={jobsList}
                            setJobsList={setJobsList}
                            setSearchValue={setSearchValue}
                            searchValue={searchValue}
                            isLoading={isLoading}
                            isError={isError}
                            page={page}
                            getAllJobList={() => getAllJobList(1, { replaceList: true })}
                            totalPages={totalPages}
                            setTotalPages={setTotalPages}
                            setReset={setReset}
                            filterJobList={filterJobList}
                            reset={reset}
                            nextBatchLoading={nextBatchLoading}
                            hasMoreData={hasMoreData}
                        />
                    </div>
                    {/* <div className="col-md-2">
                        <div className="jobList py-3 text-center desktopView">
                            <img src={header.ad1} alt="" width={"100%"} />
                        </div>
                    </div> */}
                </div>
                </div>
            </div>
        </>
    )
}

export default JobSearch